import { ChatToggleProvider } from '../contexts/ChatToggleContext';
import CaseSummary from './CaseSummary';

const CaseSummaryWrapper = ({ caseId }) => (
    <ChatToggleProvider>
        <CaseSummary caseId={caseId} />
    </ChatToggleProvider>
);

export default CaseSummaryWrapper;
